import { styled, css } from 'styled-components';
import { Media } from '@/js/libs/ui';
import { COLLAPSING_TRANSITION, NAVIGATION_WIDTH, NAVIGATION_WIDTH_COLLAPSED, SPACER_DEFAULT } from '../../constants';
export const Wrapper = styled.div `
  height: 100%;
  background: ${({ theme }) => theme.colors.grey00_1};
  box-sizing: content-box;
  transition: grid-template-columns ${COLLAPSING_TRANSITION};
  position: relative;
  overflow: hidden;
  display: grid;
  grid-template-rows: max-content auto max-content;
  @media ${Media.lgMin} {
    grid-template-columns: ${({ $collapsed }) => ($collapsed ? NAVIGATION_WIDTH_COLLAPSED : NAVIGATION_WIDTH)};
  }
  @media ${Media.smMin} {
    box-shadow: inset -1px 0 0 ${({ theme }) => theme.colors.grey10_1};
    @media ${Media.mdMax} {
      grid-template-columns: ${NAVIGATION_WIDTH};
    }
  }
  @media ${Media.xsMax} {
    grid-template-columns: 100%;
  }
`;
export const ItemsWrapper = styled.div `
  position: relative;
  padding: 10px 0;
  transition: ${COLLAPSING_TRANSITION};
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`;
export const HeaderWrapper = styled.div `
  position: relative;
  @media ${Media.lgMin} {
    width: ${({ isCollapsedNav }) => (isCollapsedNav ? NAVIGATION_WIDTH_COLLAPSED : NAVIGATION_WIDTH)};
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      width: ${({ isCollapsedNav }) => (isCollapsedNav ? `calc(100% - ${SPACER_DEFAULT})` : '100%')};
      transition: width ${COLLAPSING_TRANSITION};
      margin: 0 auto;
      height: 1px;
      background-color: ${({ theme }) => theme.colors.grey10_1};
    }
  }
  @media ${Media.mdMax} {
    ${({ isCompanySwitchView, mobileHeaderHeight }) => css `
      padding: calc(${mobileHeaderHeight}px + ${isCompanySwitchView ? SPACER_DEFAULT : '0px'}) ${SPACER_DEFAULT}
        ${isCompanySwitchView ? SPACER_DEFAULT : 0};
    `}
    ${({ isCompanySwitchView }) => isCompanySwitchView &&
    css `
        border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
      `}
  }
`;
export const HeaderInputWrapper = styled.div `
  gap: calc(${SPACER_DEFAULT} / 2);
  display: flex;
  flex-direction: column;

  @media ${Media.lgMin} {
    padding: calc(${SPACER_DEFAULT} / 2) ${SPACER_DEFAULT} ${SPACER_DEFAULT};

    ${({ isCollapsedNav }) => isCollapsedNav &&
    css `
        display: none;
      `}
  }
`;
